<template>
  <div id="app" class="home-default" :class="{
    'home-default': themeCode === 'default',
    home: themeCode === 'blue'
  }">
    <div id="outline">
      <div class="outline-content">
        <div id="container">
          <iframe src="../../../static/homeBak1.html" id="myFrame" width="100%" height="100%" scrolling="no"></iframe>
        </div>
        <!-- <div class="iframeMask" @click="iframeMask"></div> -->
        <div class="header">
          <div class="new-title">{{ pageTitle }}</div>
          <div class="outline-header-right">
            <Dropdown style="cursor:pointer;">
              <div
                style="color:#fff; width:6vw; text-align: center; line-height:2.5vw; height: 2.5vw;margin-top: 0.675vw; font-size:16px;">
                <span>{{ LangageType == 'zh' ? '中文' : 'English' }}</span>
                <Icon type="md-arrow-dropdown" style="margin-left: 0.2vw;" />
              </div>
              <DropdownMenu slot='list'>
                <DropdownItem @click.native="setLangage('en')">
                  English
                </DropdownItem>
                <DropdownItem @click.native="setLangage('zh')">
                  中文
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Dropdown id="dropDown">
              <a>
                <img
                  :src="themeCode === 'default' ? require('../../assets/default/switch.png') : require('../../assets/electricity/switch.png')"
                  :alt="$t('smartCity.HomeBak1.282798-0')">
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in HomeModeList" :key="item.id" @click.native="switchIndex(item.code, true)">{{
                  item.name }}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <img v-if="PlayIndex" @click="StopSound"
              :src="themeCode === 'default' ? require('../../assets/default/yousheng.png') : require('../../assets/electricity/yousheng.png')"
              :alt="$t('smartCity.HomeBak1.282798-1')">
            <img v-else @click="PlaySound"
              :src="themeCode === 'default' ? require('../../assets/default/wusheng.png') : require('../../assets/electricity/wusheng.png')"
              :alt="$t('smartCity.HomeBak1.282798-1')">

            <Poptip confirm :title="$t('smartCity.HomeBak1.282798-2')" placement="top-end" offset='-20' @on-ok="ok"
              @on-cancel="cancel">
              <img
                :src="themeCode === 'default' ? require('../../assets/default/tuichu.png') : require('../../assets/electricity/tuichu.png')"
                :alt="$t('smartCity.HomeBak1.282798-3')">
            </Poptip>
          </div>
        </div>
        <div class="selectBtn">
          <div class="btn" @click="goPages('smartElectricity')">
            <div class="iconBtn">
              <img src="../../assets/homeback/useE.png" alt="">
            </div>
            <div class="contentBtn">{{ $t('smartCity.HomeBak1.282798-4') }}</div>
          </div>
          <div class="btn" @click="goPages('bigScreen')">
            <div class="iconBtn">
              <img src="../../assets/homeback/useG.png" alt="">
            </div>
            <div class="contentBtn">{{ $t('smartCity.HomeBak1.282798-5') }}</div>
          </div>
        </div>
        <div class="outline-left" ref="left" :class="{ 'hide': isHidden, 'show': isShow }">
          <div class="tip1 type1" style="cursor: pointer;">
            <div class="title">
              <img src="../../assets/homeback/title_pic.png" alt="">
              <span class="desc">{{ $t('smartCity.HomeBak1.282798-6') }}</span>
            </div>
            <div class="content">
              <div id="newChart0" @click="showPopupHomeBak('AlarmHandle', '2')" style="height: 100%; width: 50%;"></div>
              <div id="newChart1" @click="showPopupHomeBak('AlarmHandle', '1')" style="height: 100%; width: 50%;"></div>
            </div>
          </div>
          <div class="tip2" @click="showPopupHomeBak('AllDevice')">
            <div class="outline-right-top-list-tab">
              <div class="outline-right-top-tab-item">{{ $t('smartCity.HomeBak1.282798-7') }}</div>
              <div class="outline-right-top-tab-item">{{ $t('smartCity.HomeBak1.282798-8') }}</div>
              <div class="outline-right-top-tab-item">{{ $t('smartCity.HomeBak1.282798-9') }}</div>
            </div>
            <div class="outline-right-top-list" id="wrapper">
              <div id="content" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 0">
                <div class="outline-right-top-list-item" v-for="(item, index) in GetDeviceDataLists" :key="index">
                  <div class="outline-right-top-list-item-time2" style="padding: 0 0.5vw;" :title="item.AddressDetail">
                    {{ item.AddressDetail }}</div>
                  <div class="outline-right-top-list-item-name2">{{ item.UserDeviceName }}</div>
                  <div class="outline-right-top-list-item-group2">
                    <img v-if="item.SwitchStatus == 1" src="../../assets/homeback/close.png" alt="">
                    <img v-else-if="item.SwitchStatus == 2" src="../../assets/homeback/open.png" alt="">
                    <span v-else>--</span>
                  </div>
                </div>
              </div>
              <div id="fakeContent" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 4"></div>

              <div class="map-right-group-list-none" v-if="GetDeviceDataLists.length == 0">{{
                $t('smartCity.HomeBak1.282798-10') }}</div>
              <Spin size="large" fix v-if="!GetDeviceDataListsMsg"></Spin>
            </div>
          </div>
          <div class="tip3 type1" style="cursor: pointer;">
            <div class="title">
              <img src="../../assets/homeback/title_pic.png" alt="">
              <span class="desc">{{ $t('smartCity.HomeBak1.282798-11') }}</span>
            </div>
            <div class="content">
              <div class="outline-right-top-list-tab">
                <div class="outline-right-top-tab-item">{{ $t('smartCity.HomeBak1.282798-12') }}</div>
                <div class="outline-right-top-tab-item">{{ $t('smartCity.HomeBak1.282798-8') }}</div>
                <div class="outline-right-top-tab-item">{{ $t('smartCity.HomeBak1.282798-13') }}</div>
              </div>
              <div class="outline-right-top-list" id="wrapper">
                <div class="outline-right-top-list-item" v-for="(item, index) in GetOperationDataList" :key="index">
                  <div class="outline-right-top-list-item-time2" style="padding: 0 0.5vw;" :title="item.CreateTime">
                    {{ item.CreateTime }}</div>
                  <div class="outline-right-top-list-item-name2">{{ item.UserDeviceName }}</div>
                  <div class="outline-right-top-list-item-group2">
                    <!-- <span style="color: aqua; margin-right: 2px;">修改</span>
                      <span style="color: red;">删除</span> -->
                    {{ item.Remark }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tip4 type1" @click="showPopupHomeBak('AllDevice')" style="cursor: pointer;">
            <div class="title">
              <img src="../../assets/homeback/title_pic.png" alt="">
              <span class="desc">{{ $t('smartCity.HomeBak1.282798-14') }}</span>
            </div>
            <div class="content">
              <div id="newChart4" style="height: 100%; width: 100%;"></div>
            </div>
          </div>
        </div>
        <div class="outline-left2" ref="left2" :class="{ 'hideLeft2': isHiddenL2, 'show': isShow }">
          <div class="tip1 type1" @click="showPopupMonitor">
            <div class="title">
              <img src="../../assets/homeback/title_pic.png" alt="">
              <span class="desc">{{ $t('smartCity.HomeBak1.282798-15') }}</span>
            </div>
            <div class="content">
              <video src="../../assets/video/myvideo.mp4" controls muted></video>
            </div>
          </div>
        </div>
        <HomeBakDeviceLIst v-if="PopupHomeBak" v-show="PopupHomeBak1" :Popuplist="Popuplist" :PopupType="PopupType"
          :PopupStatus="PopupStatus" @childEvent="IsPopupHomeBak" @childEvent1="IsPopupHomeBak1"></HomeBakDeviceLIst>
        <HomeBakDeviceDetail v-if="PopupDevice" :Popupdetail="Popupdetail" @closePopup="ClosePopupDevice"
          @closePopup1="IsPopupHomeBak2">
        </HomeBakDeviceDetail>
        <!-- PopupMonitor -->
        <Monitor v-if="PopupMonitor" :Popuplist="MonitorList" @childEvent="closePopupMonitor"></Monitor>
        <div class="outline-right" ref="right" :class="{ 'hideRight': isHiddenR, 'show': isShow }">
          <div class="r_tip1 type1">
            <div class="title">
              <img src="../../assets/homeback/title_pic.png" alt="">
              <span class="desc">{{ $t('smartCity.HomeBak1.282798-16') }}</span>
            </div>
            <div class="content">
              <div id="newChart3" @click="showPopupHomeBak('online', '1')" style="height: 100%; width: 50%;"></div>
              <div id="newChart2" @click="showPopupHomeBak('online', '0')" style="height: 100%; width: 50%;"></div>
            </div>
          </div>
          <div class="r_tip2 type1" @click="showPopupHomeBak('AlarmDevice')" style="cursor: pointer;">
            <div class="title">
              <img src="../../assets/homeback/title_pic.png" alt="">
              <span class="desc">{{ $t('smartCity.HomeBak1.282798-17') }}</span>
            </div>
            <div class="content">
              <div id="newChart5" style="height: 100%; width: 100%;"></div>
            </div>
          </div>
          <div class="r_tip3 type1" @click="showPopupHomeBak('ZuiJinAlarmDevice')">
            <div class="title">
              <img src="../../assets/homeback/title_pic2.png" alt="">
              <span class="desc">{{ $t('smartCity.HomeBak1.282798-18') }}</span>
            </div>
            <div class="content">
              <div class="outline-left-list" id="wrapper3">
                <div id="content3" class="outline-left-lists2" v-if="GetAbDataLists.length > 0">
                  <div class="outline-left-top-item" v-for="(item, index) in GetAbDataLists" :key="item.Id"
                    @dblclick="deviceDetails(item)">
                    <div class="outline-left-top-item-time">
                      <div class="time-content">{{ item.AbnormalTime | intercept }}</div>
                    </div>

                    <div class="outline-left-top-item-name">
                      {{ item.UserDeviceName }}
                    </div>
                    <div class="outline-left-top-item-group">{{ item.AbnormalName }}</div>
                  </div>
                </div>
                <div id="fakeContent3" class="outline-left-lists" v-if="GetAbDataLists.length > 6"></div>
                <div class="map-right-group-list-none" v-else>{{ $t('smartCity.HomeBak1.282798-19') }}</div>

                <Spin size="large" fix v-if="!GetAbDataListsMsg"></Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import echarts from "echarts";
import Cookies from "js-cookie";
import api from "../../api/request.js";
import TreeModel from "../useGas/views/area/mods/tree.vue";
import HomeBakDeviceLIst from './HomeBakDeviceList.vue';
import HomeBakDeviceDetail from './HomeBakDeviceDetail.vue';
import Monitor from './Monitor.vue'

export default {
  components: {
    TreeModel,
    HomeBakDeviceLIst,
    HomeBakDeviceDetail,
    Monitor
  },
  name: "App",
  data() {
    return {
      cityName: Cookies.get("cityName") || this.$t('smartCity.HomeBak1.282798-20'),
      TittleName: "", // 中文title
      TittleNameEN: "", // 英文title
      ImageUrl: "",
      themeCode: "",

      map: null, // 地图

      config: {},
      devicesConfig: {},
      roomConfig: {},

      parameter: "",
      headTitle: this.$t('smartCity.HomeBak1.282798-21'),
      outlineArea: false,
      query: {},
      devicesList: [], // 设备
      GetDeviceDataLists: [], // 设备相关数据列表
      GetDeviceDataListsMsg: false,
      GetOperationDataList: [], // 当天操作日志数据列表
      GetOperationDataListMsg: false,
      selectedArea: {}, // 选择的市
      selectedVillage: '', // 选择的区
      selectedThreeLevel: {},
      selectedFourLevel: {},
      deviceCatCountList: [],
      deviceCatCountListAll: [],
      deviceAbnormalCountList: [],
      GetAbDataLists: [], // 及时告警消息列表
      GetAbDataCount: 0, // 数量
      GetAbDataListsMsg: false,
      GetEchartAbDataMsg: false,
      processed: '', // 已处理数
      offsetMsg: false,
      HomeModeList: [],//首页模式列表
      PlayIndex: false, // 播放按钮
      PopupHomeBak: false,//弹窗-设备列表是否创建 v-if
      PopupHomeBak1: true,//弹窗 - 设备列表是否显示 v-show
      Popuplist: [], //弹窗-设备列表
      PopupType: 'AllDevice',//弹窗 - 列表类型
      PopupDevice: false,//弹窗-设备详情是否显示
      Popupdetail: {},//弹窗 - 设备详情
      GetDeviceDataLists1: [],//告警设备列表数据
      GetDeviceDataLists2: [],//报警设备列表 --未处理
      GetDeviceDataLists3: [],//报警设备列表 --已处理
      GetDeviceDataLists4: [],//在线设备列表
      GetDeviceDataLists5: [],//离线设备列表
      PopupStatus: 1,   //设备状态 --在线/离线/处理/未处理
      timeValue: '2023-7-13',
      PopupMonitor: false,
      GetMonitorDataLists: [], // 摄像头设备相关数据列表
      GetMonitorDataListsMsg: false,
      MonitorList: [],
      isHidden: false,
      isHiddenL2: false,
      isHiddenR: false,
      isShow: false,
      monitoItems: localStorage.getItem('monitoItems'),//点击打开设备详情时传的设备数据
      LangageType: localStorage.getItem('language'),
      pageTitle: '智慧农业智维管理平台',
    };
  },
  created() {
    const _this = this;
    _this.themeCode = _this.$store.getters.getThemeCode;
    const { TittleName, TittleNameEN, ImageUrl } = JSON.parse(
      Cookies.get("AdminData")
    );

    _this.TittleName = TittleName;
    _this.TittleNameEN = TittleNameEN;
    _this.ImageUrl = ImageUrl;
    _this.HomeModeList = _this.$store.getters.getHomeModeList;
    // 获取播放状态
    _this.PlayIndex = Cookies.get('PlayIndex') == 'true' ? true : false;
    // settimeout中是给ifram添加点击事件,获取到iframe节点需要在打开页面若干秒之后，要不然获取不到
    setTimeout(() => {
      var currentIframe = document.getElementById("myFrame");
      var currentDoc = currentIframe.contentDocument || currentIframe.contentWindow.document;
      currentDoc.addEventListener("click", function () {
        _this.monitoItems = localStorage.getItem('monitoItems')
      }, false);
    }, 4000)
  },

  computed: {},

  mounted() {
    let _this = this;
    _this.timeValue = _this.getDate(0);
    // 获取设备列表
    _this.GetUserDevicesPage();
    // 获取报警设备列表
    _this.GetCurrRoomAbDevices();
    //获取报警已处理设备列表
    _this.GetDeviceAbnormal()
    //获取报警未处理设备列表
    _this.GetDeviceAbnormal1()
    //获取离线设备
    _this.getUserDevicesPagesNew()
    //获取在线设备
    _this.getUserDevicesPagesNew1()
    // 当天操作日志数据（yhj）
    _this.GetOperationData();
    // 获取设备种类数量统计
    _this.GetDeviceCatCount('all');
    // 获取当月最近7天每天的设备异常次数
    _this.GetDeviceAbnormalCountMonth()
    // 根据集团 公司 部门获取设备异常（yhj）
    _this.GetDeviceAbnormalPageListWith3Code();
    // 图表在线离线数据（yhj）
    _this.GetDeviceZLData()
    // 告警异常处理情况图表数据
    _this.GetEchartAbData();
    // 获取摄像头数据
    _this.getDeviceMonitor()


    // _this.GetDeviceZLData();

    _this.GetRoshRoomList();

    if (this.$driver.isActivated) {
      let steps = [
        {
          element: "#enterSys",
          popover: {
            title: this.$t('smartCity.HomeBak1.282798-22'),
            description: this.$t('smartCity.HomeBak1.282798-23'),
            position: "left",
            className: 'robotLeft'
          }
        },
      ]
      this.$nextTick(() => {
        this.$driver.defineSteps(steps);
        this.$driver.start();
      })
    }
  },
  watch: {
    monitoItems: {
      handler(newVal, oldVal) {
        let _this = this
        _this.Popupdetail = JSON.parse(newVal)
        console.log(this.$t('smartCity.HomeBak1.282798-24'), newVal)
        console.log(this.$t('smartCity.HomeBak1.282798-25'), oldVal)
        _this.IsPopupHomeBak1()
      },
    },
    // Popupdetail:{
    //   handler(newVal,oldVal){
    //     console.log('Popupdetail',newVal,oldVal)
    //   }
    // }
  },
  methods: {
    //更改语言
    setLangage(type) {
      localStorage.setItem('language', type)
      this.$i18n.locale = type
      this.LangageType = type
    },
    //获取当天日期
    getDate(n) {
      let oneDay = 24 * 60 * 60 * 1000
      let date = new Date(Date.now() - n * oneDay)
      let Y = date.getFullYear()
      let M = date.getMonth() + 1
      let D = date.getDate()
      return Y + '-' + M + '-' + D;
    },
    // 渐隐动画
    clickAnimate() {
      this.$refs.left.classList.remove('show')
      this.$refs.left2.classList.remove('show')
      this.$refs.right.classList.remove('show')
      this.isShow = false
      this.isHidden = true
      this.isHiddenL2 = true
      this.isHiddenR = true
    },
    // 渐显动画
    clickAnimate1() {
      this.$refs.left.classList.remove('hide')
      this.$refs.left2.classList.remove('hideLeft2')
      this.$refs.right.classList.remove('hideRight')
      this.isHidden = false
      this.isHiddenL2 = false
      this.isHiddenR = false
      this.isShow = true
    },


    //打开设备列表弹窗
    showPopupHomeBak(type, Status) {
      this.clickAnimate()
      setTimeout(() => {
        this.PopupDevice = false
        this.PopupHomeBak = true
        this.PopupHomeBak1 = true
        this.PopupType = type
        if (Status) {
          this.PopupStatus = Status
        }
        switch (type) {
          case 'AllDevice':
            this.Popuplist = this.GetDeviceDataLists;
            break;
          case 'AlarmDevice':
            this.Popuplist = this.GetDeviceDataLists1;
            break;
          case 'AlarmHandle':
            // 未处理是1，已经处理是2
            if (Status == '1') {
              this.Popuplist = this.GetDeviceDataLists2;
            } else {
              this.Popuplist = this.GetDeviceDataLists3;
            }
            break;
          case 'online':
            if (Status === '0') {
              this.Popuplist = this.GetDeviceDataLists5;
            } else {
              this.Popuplist = this.GetDeviceDataLists4;
            }
            break;
          case 'ZuiJinAlarmDevice':
            this.Popuplist = this.GetAbDataLists
            break;
          default:
            this.Popuplist = this.GetDeviceDataLists;
            break;
        }
      }, 100);
    },
    //关闭设备列表弹窗
    IsPopupHomeBak(str) {
      this.clickAnimate1()
      this.PopupHomeBak = str
    },
    //关闭设备列表弹窗和打开设备详情弹窗
    IsPopupHomeBak1(item) {
      let _this = this
      //从列表点击时 Popupdetail来自列表的数据,从地图坐标进行点击时Popupdetail来自监听iframe点击事件时取到的缓存
      // 门窗开关 7febbea4-0326-496d-9b71-5b058729cb42
      let DeviceId = ''
      if (item) {
        DeviceId = item.DeviceId
        _this.Popupdetail = item
      } else {
        DeviceId = _this.Popupdetail.DeviceId
      }
      if (DeviceId == '7febbea4-0326-496d-9b71-5b058729cb42') {
        _this.$Message['error']({
          background: true,
          content: this.$t('smartCity.HomeBak1.282798-26')
        });
        return false
      }
      _this.clickAnimate() //将两边的表格移开的动画
      this.PopupHomeBak1 = false
      this.PopupDevice = true
    },

    //打开弹窗列表和关闭设备详情弹窗
    IsPopupHomeBak2(item) {
      // this.PopupHomeBak = true
      this.PopupHomeBak1 = true
      this.PopupDevice = false
    },
    //关闭设备详情弹窗
    ClosePopupDevice() {
      this.clickAnimate1()
      this.PopupDevice = false
    },
    // 打开摄像头列表弹框
    showPopupMonitor() {
      this.clickAnimate()
      this.PopupMonitor = true
      this.MonitorList = this.GetMonitorDataLists
    },
    // 关闭摄像头列表弹框
    closePopupMonitor(str) {
      this.clickAnimate1()
      this.PopupMonitor = str
    },
    // 获取摄像头数据列表
    getDeviceMonitor() {
      if (!Cookies.get('AdminData')) {
        return;
      }
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      let cam = 'cam';
      api({
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPage?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}&pageIndex=1&pageSize=100&deviceType=${cam}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.GetMonitorDataListsMsg = true;
        if (res.Success) {
          _this.GetMonitorDataLists = res.Data;
          // _this.$nextTick(function () {
          //   _this.Carousel();
          // });
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.GetMonitorDataListsMsg = true;
      });
    },

    // 获取设备列表
    GetUserDevicesPage() {
      if (!Cookies.get('AdminData')) {
        return;
      }
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetDeviceDataListsMsg = false;
      api({
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPageV2?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}&pageIndex=1&pageSize=100`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.GetDeviceDataListsMsg = true;
        if (res.Success) {
          _this.GetDeviceDataLists = res.Data;
          _this.$nextTick(function () {
            _this.Carousel();
          });
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.GetDeviceDataListsMsg = true;
      });
    },

    // 获取告警设备列表
    GetCurrRoomAbDevices() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetCurrRoomAbDevices`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          pageIndex: 1,
          pageSize: 100,
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        console.log('AlarList', res.Data)
        if (res.Success) {
          _this.GetDeviceDataLists1 = res.Data;
        }

      })
    },

    //获取报警设备列表 --未处理
    GetDeviceAbnormal() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=100&pstate=1&isAdmin=${AdminData.IsAdmin}&startDt=${_this.timeValue}&endDt=${_this.timeValue}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.GetDeviceDataLists2 = res.Data;
        }
      })
    },

    //获取报警设备列表 --已处理
    GetDeviceAbnormal1() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=100&pstate=2&isAdmin=${AdminData.IsAdmin}&startDt=${_this.timeValue}&endDt=${_this.timeValue}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.GetDeviceDataLists3 = res.Data;
        }
      })
    },

    //获取在线设备列表
    getUserDevicesPagesNew() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPageV2`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          pageIndex: 1,
          pageSize: 1000,
          onlineState: '1',
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          console.log(_this.$t('smartCity.HomeBak1.282798-27'), res.Data)
          _this.GetDeviceDataLists4 = res.Data;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    //获取离线设备列表
    getUserDevicesPagesNew1() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPageV2`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          pageIndex: 1,
          pageSize: 1000,
          onlineState: '0',
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          console.log(this.$t('smartCity.HomeBak1.282798-28'), res.Data)
          _this.GetDeviceDataLists5 = res.Data;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {

      });
    },






    Carousel() {
      this.roll(80, document.getElementById("content"), document.getElementById("fakeContent"), document.getElementById("wrapper"), '#wrapper');
      this.roll(80, document.getElementById("content2"), document.getElementById("fakeContent2"), document.getElementById("wrapper2"), '#wrapper2');
    },
    roll(t, content, fakeContent, wrapper, wrapperId) {
      let _this = this;

      if (!content) {
        return;
      }

      if (fakeContent) {
        fakeContent.innerHTML = content.innerHTML;
      }

      // 开始无滚动时设为0
      wrapper.scrollTop = 0;

      let timer = null;

      //鼠标事件绑定
      $(wrapperId).hover(function () {
        clearInterval(timer);
        timer = null
      }, function () {
        timer = setInterval(() => {
          _this.rollStart(wrapper, content)
        }, t);
      }).mouseout();

    },
    // 开始滚动函数
    rollStart(wrapper, content) {
      // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
      if (wrapper.scrollTop >= content.scrollHeight) {
        wrapper.scrollTop = 0;
      } else {
        wrapper.scrollTop++;
      }
    },

    // 当天操作日志数据（yhj）
    GetOperationData() {
      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetOperationDataListMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetOperationData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}&pageIndex=1&pageSize=100`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.GetOperationDataListMsg = true;
        if (res.Success) {

          _this.GetOperationDataList = res.Data;

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        if (err.data.Code == -9) {
          if (window.location.host == 'xed.hxpwr.com') {
            _this.$router.push({
              name: 'xed_login'
            })
          } else {
            _this.$router.push({
              name: 'login'
            })
          }
        }
      });
    },
    // 获取设备种类数量统计
    GetDeviceCatCount(flag) {
      if (!Cookies.get('AdminData')) {
        return;
      }
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: "get",
        url: `api/CommElecDevice/GetDeviceCatCount`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }, 'yhj').then(res => {
        if (flag == 'all') {
          this.deviceCatCountListAll = res
          _this.drawNewChart4();
        } else {
          let deviceCatCountList = [{ name: this.$t('smartCity.HomeBak1.282798-29'), value: 0 }, { name: this.$t('smartCity.HomeBak1.282798-30'), value: 0 }, { name: this.$t('smartCity.HomeBak1.282798-31'), value: 0 }, { name: this.$t('smartCity.HomeBak1.282798-32'), value: 0 }];
          res.map((item, index) => {
            if (item.name == this.$t('smartCity.HomeBak1.282798-29')) {
              deviceCatCountList[0].value = item.value;
            } else if (item.name == this.$t('smartCity.HomeBak1.282798-30')) {
              deviceCatCountList[1].value = item.value;
            } else if (item.name == this.$t('smartCity.HomeBak1.282798-31')) {
              deviceCatCountList[2].value = item.value;
            } else if (item.name == this.$t('smartCity.HomeBak1.282798-32')) {
              deviceCatCountList[3].value = item.value;
            }
          })
          this.deviceCatCountList = deviceCatCountList;
        }
      });
    },
    // 获取当月最近7天每天的设备异常次数
    GetDeviceAbnormalCountMonth() {
      if (!Cookies.get('AdminData')) {
        return;
      }
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: "get",
        url: `api/CommElecDevice/DeviceAbnormalCountMonth?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }, 'yhj').then(res => {
        this.deviceAbnormalCountList = res;
        let xData = [];
        let yData = [];
        res.map((item) => {
          xData.push(item.name);
          yData.push(item.value);
        })
        this.drawNewChart5(xData, yData);
      });
    },
    // 根据集团 公司 部门获取设备异常（yhj）
    GetDeviceAbnormalPageListWith3Code(type) {
      if (!Cookies.get('AdminData')) {
        if (window.location.host == 'xed.hxpwr.com') {
          this.$router.push({
            name: 'xed_login'
          })
        } else {
          this.$router.push({
            name: 'login'
          })
        }
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetAbDataListsMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=100&pstate=1&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        _this.GetAbDataListsMsg = true;
        if (res.Success) {

          _this.GetAbDataLists = res.Data;
          _this.GetAbDataCount = res.TotalCount;
          // _this.numScroll('itemImg3', _this.GetAbDataCount);

          if (type == 'self') {
            _this.offsetMsg = true;
            setTimeout(() => {
              _this.offsetMsg = false;
            }, 2000)
          } else {
            _this.$nextTick(function () {
              _this.roll(50, document.getElementById("content3"), document.getElementById("fakeContent3"), document.getElementById("wrapper3"), '#wrapper3');
            });
          }

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    // 图表在线离线数据（yhj）
    GetDeviceZLData() {
      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetDeviceZLData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          let series = [];
          res.Data.forEach((item) => {
            series.push({
              value: item.value,
              name: item.name,
            })
          })
          _this.$nextTick(function () {
            _this.drawNewChart2(series);
            _this.drawNewChart3(series)

          });

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        // if (err.data.Code == -9 || err.data.Code == -1) {
        // 	_this.$router.push({
        // 		name: 'login'
        // 	})
        // }
      });
    },
    // 告警异常处理情况图表数据
    GetEchartAbData() {
      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetEchartAbDataMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetEchartAbData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.GetEchartAbDataMsg = true;
        if (res.Success) {

          let series = [];
          res.Data.forEach((item) => {
            series.push({
              value: item.value,
              name: item.name
            })

            // if (item.name == this.$t('smartCity.HomeBak1.282798-33')) {
            //   _this.processed = item.value
            // }
          })

          if (series.length == 0) {
            series = [];
            series.push({
              value: 0,
              name: this.$t('smartCity.HomeBak1.282798-33')
            }, {
              value: 0,
              name: this.$t('smartCity.HomeBak1.282798-34')
            })

            // _this.processed = 0
          }


          _this.$nextTick(function () {
            _this.drawNewChart1(series);
            _this.drawNewChart0(series);
          });

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        // if (err.data.Code == -9 || err.data.Code == -1) {
        // 	_this.$router.push({
        // 		name: 'login'
        // 	})
        // }
      });
    },

    // 数字翻牌器
    // numScroll(id, maxNum, time = 1000) {
    //   var numDom = document.getElementById(id)
    //   if (!numDom) {
    //     return;
    //   }
    //   var numInit = 0
    //   var addNum = maxNum / (time / 10)
    //   var minTime = time / maxNum
    //   var t = setInterval(function () {
    //     if (numInit >= maxNum) {
    //       clearInterval(t)
    //       numDom.innerText = maxNum
    //     } else {
    //       numInit += addNum
    //       numDom.innerText = Math.round(numInit)
    //     }
    //   }, 7)
    // },

    // 最近报警已处理情况图表
    drawNewChart0(series) {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart0'))
      let angle = 0;
      let timerId;
      let value
      let total
      let text
      let text1
      if (series[1]) {
        value = series[1].value
        total = parseInt(series[0].value) + parseInt(series[1].value)
        text = series[1].name
        text1 = series[1].value
      } else {
        value = 0
        total = parseInt(series[0].value) + 0
        text = this.$t('smartCity.HomeBak1.282798-33')
        text1 = 0
      }
      let percentage
      if (total == 0) {
        percentage = 0 + '%'
      } else {
        if (value == 0) {
          percentage = 0 + '%'
        } else {
          percentage = (((value / total).toFixed(2)) * 100) + '%';
        }
      }
      let option = {
        graphic: [{
          type: 'text',
          left: 'center', // 文字水平居中对齐
          bottom: '3%', // 距离底部的距离
          style: {
            fill: '#fff', // 文字颜色
            text: text + ' ' + text1, // 要显示的文字内容
            font: '14px Arial' // 文字字体和大小
          }
        }],
        title: {
          text: '{a|' + percentage + '}',
          x: 'center',
          y: 'center',
          textStyle: {
            rich: {
              a: {
                fontSize: 16,
                color: '#ffffff',
                fontWeight: 'bold'
              },
            }
          }
        },
        series: [
          //外环
          {
            name: this.$t('smartCity.HomeBak1.282798-35'),
            type: 'pie',
            silent: true,
            clockwise: true,
            radius: ['55%', '56%'],
            label: {
              show: false,
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              color: '#21e1cf',
            },
            data: [0]
          },
          {
            name: '',
            type: 'pie',
            center: ['50%', '50%'], //圆心的位置
            radius: ['35%', '40%'], //环形图的本质就在这里 [内半径!=0，外半径] 外半径越大，圆越大
            avoidLabelOverlap: false, //做同心圆用到
            clockwise: false, //顺时针排列
            startAngle: 90, //起始角度 影响不大
            label: {
              show: false, //false不显示饼图上的标签
              // position: 'center', //inside（在饼图上显示）,outside(默认就会出现引导线) center
              // formatter: '{d}%',
              // fontSize: 50,
              // fontWeight: 'bold',
            },
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    //外环发光
                    // shadowBlur: 10,
                    // shadowColor: '#9bfeff',
                    color: '#0febc8'
                  }
                }
              },
              {
                value: total - value,
                label: {
                  normal: {
                    show: false
                  }
                },
                itemStyle: {
                  normal: {
                    color: "rgba(255,255,255,.5)"
                  }
                }
              }
            ],

            emphasis: {
              scale: false,

            },
          },
          //colors[0]line
          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6,
                  startAngle: ((0 + angle) * Math.PI) / 180,
                  endAngle: ((90 + angle) * Math.PI) / 180,
                },
                style: {
                  stroke: '#14e9cf',
                  fill: 'transparent',
                  lineWidth: 1,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: 'ring5', //        //colors[0]dot
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6;
              let point = getCirlPoint(x0, y0, r, 90 + angle);
              return {
                type: 'circle',
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 2,
                },
                style: {
                  stroke: '#14e9cf',
                  fill: '#14e9cf',
                },
                silent: true,
              };
            },
            data: [0],
          },
          // 蓝色

          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6,
                  startAngle: ((180 + angle) * Math.PI) / 180,
                  endAngle: ((270 + angle) * Math.PI) / 180,
                },
                style: {
                  stroke: '#14e9cf',
                  fill: 'transparent',
                  lineWidth: 1,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6;
              let point = getCirlPoint(x0, y0, r, 180 + angle);
              return {
                type: 'circle',
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 2,
                },
                style: {
                  stroke: '#14e9cf', //绿
                  fill: '#14e9cf',
                },
                silent: true,
              };
            },
            data: [0],
          },
        ],
      };
      myChart.setOption(option, true);
      //获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
      function getCirlPoint(x0, y0, r, angle) {
        let x1 = x0 + r * Math.cos((angle * Math.PI) / 180);
        let y1 = y0 + r * Math.sin((angle * Math.PI) / 180);
        return {
          x: x1,
          y: y1,
        };
      }

      function draw() {
        angle = angle + 3;
        myChart.setOption(option, true);
        //window.requestAnimationFrame(draw);
      }
      draw();
      setTimeout(function () {
        if (timerId) {
          clearInterval(timerId);
        }
        timerId = setInterval(function () {
          //用setInterval做动画感觉有问题
          draw();
        }, 100);
      }, 500);
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      });
      // 饼图点击跳转到指定页面
      // myChart.on('click', function(param) {
      //   _this.openPopup(3, param.name == this.$t('smartCity.HomeBak1.282798-33') ? '今日已处理' : param.name == this.$t('smartCity.HomeBak1.282798-34') ? '今日未处理' : '今日误报', param.name ==
      //     this.$t('smartCity.HomeBak1.282798-33') ? '2' : param.name == this.$t('smartCity.HomeBak1.282798-34') ? '1' : '3')
      // });
    },
    drawNewChart1(series) {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart1'))
      let angle = 0;
      let timerId;
      let value = series[0].value;
      let total
      if (series[1]) {
        total = parseInt(series[0].value) + parseInt(series[1].value)
      } else {
        total = parseInt(series[0].value) + 0
      }
      // let total = parseInt(series[0].value) + parseInt(series[1].value || 0)
      let percentage
      if (total == 0) {
        percentage = 0 + '%'
      } else {
        if (value == 0) {
          percentage = 0 + '%'
        } else {
          percentage = (((value / total).toFixed(2)) * 100) + '%';
        }
      }
      let text = series[0].name;
      let text1 = series[0].value;
      let option = {
        graphic: [{
          type: 'text',
          left: 'center', // 文字水平居中对齐
          bottom: '3%', // 距离底部的距离
          style: {
            fill: '#fff', // 文字颜色
            text: text + ' ' + text1, // 要显示的文字内容
            font: '14px Arial' // 文字字体和大小
          }
        }],
        title: {
          text: '{a|' + percentage + '}',
          x: 'center',
          y: 'center',
          textStyle: {
            rich: {
              a: {
                fontSize: 16,
                color: '#ffffff',
                fontWeight: 'bold'
              },
            }
          }
        },
        series: [
          //外环
          {
            name: this.$t('smartCity.HomeBak1.282798-35'),
            type: 'pie',
            silent: true,
            clockwise: true,
            radius: ['55%', '56%'],
            label: {
              show: false,
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              color: '#e44637',
            },
            data: [0]
          },
          {
            name: '',
            type: 'pie',
            center: ['50%', '50%'], //圆心的位置
            radius: ['35%', '40%'], //环形图的本质就在这里 [内半径!=0，外半径] 外半径越大，圆越大
            avoidLabelOverlap: false, //做同心圆用到
            clockwise: false, //顺时针排列
            startAngle: 90, //起始角度 影响不大
            label: {
              show: false, //false不显示饼图上的标签
              // position: 'center', //inside（在饼图上显示）,outside(默认就会出现引导线) center
              // formatter: '{d}%',
              // fontSize: 50,
              // fontWeight: 'bold',
            },
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    color: "#e44637",
                    //外环发光
                    // shadowBlur: 10,
                    // shadowColor: '#9bfeff',

                  }
                }
              },
              {
                value: total - value,
                label: {
                  normal: {
                    show: false
                  }
                },
                itemStyle: {
                  normal: {
                    color: 'rgba(255,255,255,.5)'
                  }
                }
              }
            ],

            emphasis: {
              scale: false,

            },
          },
          //colors[0]line
          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6,
                  startAngle: ((0 + angle) * Math.PI) / 180,
                  endAngle: ((90 + angle) * Math.PI) / 180,
                },
                style: {
                  stroke: '#e44637',
                  fill: 'transparent',
                  lineWidth: 1,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: 'ring5', //        //colors[0]dot
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6;
              let point = getCirlPoint(x0, y0, r, 90 + angle);
              return {
                type: 'circle',
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 2,
                },
                style: {
                  stroke: '#e44637',
                  fill: '#e44637',
                },
                silent: true,
              };
            },
            data: [0],
          },
          // 蓝色

          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6,
                  startAngle: ((180 + angle) * Math.PI) / 180,
                  endAngle: ((270 + angle) * Math.PI) / 180,
                },
                style: {
                  stroke: '#e44637',
                  fill: 'transparent',
                  lineWidth: 1,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: 'ring5', // 蓝色
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2.5) * 0.6;
              let point = getCirlPoint(x0, y0, r, 180 + angle);
              return {
                type: 'circle',
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 2,
                },
                style: {
                  stroke: '#e44637',
                  fill: '#e44637',
                },
                silent: true,
              };
            },
            data: [0],
          },
        ],
      };
      myChart.setOption(option, true);
      //获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
      function getCirlPoint(x0, y0, r, angle) {
        let x1 = x0 + r * Math.cos((angle * Math.PI) / 180);
        let y1 = y0 + r * Math.sin((angle * Math.PI) / 180);
        return {
          x: x1,
          y: y1,
        };
      }

      function draw() {
        angle = angle + 3;
        myChart.setOption(option, true);
        //window.requestAnimationFrame(draw);
      }
      draw();
      setTimeout(function () {
        if (timerId) {
          clearInterval(timerId);
        }
        timerId = setInterval(function () {
          //用setInterval做动画感觉有问题
          draw();
        }, 100);
      }, 500);
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      });
      // 饼图点击跳转到指定页面
      // myChart.on('click', function(param) {
      //   _this.openPopup(3, param.name == this.$t('smartCity.HomeBak1.282798-33') ? '今日已处理' : param.name == this.$t('smartCity.HomeBak1.282798-34') ? '今日未处理' : '今日误报', param.name ==
      //     this.$t('smartCity.HomeBak1.282798-33') ? '2' : param.name == this.$t('smartCity.HomeBak1.282798-34') ? '1' : '3')
      // });
    },
    // 设备状态图表
    drawNewChart2(series) {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart2'))
      let value = series[0].value;
      let total = parseInt(series[0].value) + parseInt(series[1].value)
      let percentage = (((value / total).toFixed(2)) * 100) + '%';
      let text = series[0].name;
      let dataValue = value.toString();
      myChart.setOption({
        graphic: [{
          type: 'text',
          left: 'center', // 文字水平居中对齐
          bottom: 10, // 距离底部的距离
          style: {
            fill: '#fff', // 文字颜色
            text: text, // 要显示的文字内容
            font: '14px Arial' // 文字字体和大小
          }
        }],
        title: {
          text: '{a|' + percentage + '}\n{b|' + dataValue + '}',
          x: 'center',
          y: 'center',
          textStyle: {
            rich: {
              a: {
                fontSize: 16,
                color: '#ffffff',
                fontWeight: 'bold',
                lineHeight: 24
              },
              b: {
                fontSize: 10,
                color: '#ffffff',
                fontWeight: 'normal'
              }
            }
          }
        },
        series: [
          //内环
          {
            name: this.$t('smartCity.HomeBak1.282798-36'),
            type: 'pie',
            silent: true,
            clockwise: true,
            radius: ['40%', '41%'],
            label: {
              show: false,
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              color: 'rgba(255,255,255,.5)',
            },
            data: [0]
          },
          //外环
          {
            name: '',
            type: 'pie',
            radius: ['46%', '55%'],
            silent: true,
            clockwise: true,
            startAngle: 180,
            label: {
              show: false,
            },
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    //外环发光
                    shadowBlur: 10,
                    shadowColor: '#fff',
                    color: 'rgba(255,255,255,.5)'
                  }
                }
              },
              {
                value: 100 - value,
                label: {
                  normal: {
                    show: false
                  }
                },
                itemStyle: {
                  normal: {
                    shadowBlur: 10,
                    shadowColor: '#fff',
                    color: "#fbec1b"
                  }
                }
              }
            ]
          },
        ]
      });

      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },
    drawNewChart3(series) {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart3'))
      let value = series[1].value;
      let total = parseInt(series[0].value) + parseInt(series[1].value)
      let percentage = (((value / total).toFixed(2)) * 100) + '%';
      let text = series[1].name;
      let dataValue = value.toString();
      let option = {
        graphic: [{
          type: 'text',
          left: 'center', // 文字水平居中对齐
          bottom: 10, // 距离底部的距离
          style: {
            fill: '#fff', // 文字颜色
            text: text, // 要显示的文字内容
            font: '14px Arial' // 文字字体和大小
          }
        }],
        title: {
          text: '{a|' + percentage + '}\n{b|' + dataValue + '}',
          x: 'center',
          y: 'center',
          textStyle: {
            rich: {
              a: {
                fontSize: 16,
                color: '#ffffff',
                fontWeight: 'bold',
                lineHeight: 24
              },
              b: {
                fontSize: 10,
                color: '#ffffff',
                fontWeight: 'normal'
              }
            }
          }
        },
        series: [
          //内环
          {
            name: this.$t('smartCity.HomeBak1.282798-36'),
            type: 'pie',
            silent: true,
            clockwise: true,
            radius: ['40%', '41%'],
            label: {
              show: false,
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              color: 'rgba(255,255,255,.5)',
            },
            data: [0]
          },
          //外环
          {
            name: '',
            type: 'pie',
            radius: ['46%', '55%'],
            silent: true,
            clockwise: true,
            startAngle: 90,
            label: {
              show: false,
            },
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    //外环发光
                    shadowBlur: 10,
                    shadowColor: '#fff',
                    // color: '#fbec1b'
                    color: '#1ce1c7'
                  }
                }
              },
              {
                value: 100 - value,
                label: {
                  normal: {
                    show: false
                  }
                },
                itemStyle: {
                  normal: {
                    shadowBlur: 10,
                    shadowColor: '#fff',
                    color: "rgba(255,255,255,.5)"
                  }
                }
              }
            ]
          },
        ]
      }
      myChart.setOption(option, true);

      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },

    // 设备种类图表
    drawNewChart4() {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart4'))
      let xAxisData = []
      _this.deviceCatCountListAll.forEach((item) => {
        xAxisData.push(item.name)
      })
      myChart.setOption({
        tooltip: {
          trigger: 'item'
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "20%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#BDD8FB",
              fontSize: 12,
            },
          },
          axisLabel: {
            color: "#BDD8FB",
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          data: xAxisData,
        },
        yAxis: {
          type: "value",
          min: 0,
          minInterval: 1,
          nameTextStyle: {
            fontSize: 12,
            color: "#BDD8FB",
            align: "center",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.15)",
            },
          },
          splitArea: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#BDD8FB'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 12,
            fontFamily: "Bebas",
            color: "#BDD8FB",
          },
        },
        series: [{
          type: 'bar',
          data: _this.deviceCatCountListAll,
          hoverAnimation: true,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(
              0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(223, 218, 38,1)'
              },
              {
                offset: 1,
                color: 'rgba(223, 218, 38, .1)'
              }
            ]
            )
          }
        }]
      });
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },
    // 最近7天每天的设备异常次数图表
    drawNewChart5(xData, yData) {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart5'))
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,.6)",
          borderColor: "rgba(147, 235, 248, .8)",
          textStyle: {
            color: "#FFF",
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "20%",
          containLabel: true,
        },

        xAxis: {
          name: this.$t('smartCity.HomeBak1.282798-37'),
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#BDD8FB",
              fontSize: 12,
            },
          },
          axisLabel: {
            // interval:0,
            color: "#BDD8FB",
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          data: xData,
        },
        yAxis: {
          name: this.$t('smartCity.HomeBak1.282798-38'),
          type: "value",
          min: 0,
          minInterval: 1,
          nameTextStyle: {
            fontSize: 12,
            color: "#BDD8FB",
            align: "center",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.15)",
              // type: 'dashed', // dotted 虚线
            },
          },
          splitArea: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#BDD8FB'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 12,
            fontFamily: "Bebas",
            color: "#BDD8FB",
          },
        },
        series: [
          {
            type: "line",
            symbol: "none",
            // showSymbol: false,
            smooth: true, // 是否曲线
            name: this.$t('smartCity.HomeBak1.282798-38'),
            data: yData, // 纵坐标数据
            lineStyle: {
              color: '#dfda26',
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,  //右
                y: 0,  //下
                x2: 0,  //左
                y2: 1,  //上
                colorStops: [
                  {
                    offset: 0.1,
                    color: '#d2d02b' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'transparent' // 100% 处的颜色
                  }
                ]
              },
            },
          }
        ],
      });
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },

    // 前往智慧用电/安全用气
    goPages(page) {
      this.$router.push({
        name: page,
        query: {
          flag: true
        }
      })
    },
    switchIndex(type, flag) {
      console.log('type', type, flag)
      let _this = this;
      if (flag && type != 'DMapMode') {
        this.setHome(type);
      }
      if (type == 'newHome') {
        _this.$router.push({
          name: 'home',
        })
        location.reload()
        this.GetEchartAbData("new");
        this.GetDeviceZLData("new");
        this.getUserDevicesPageV2();
        this.GetDeviceAbnormalCountMonth();
        // 获取设备种类
        this.GetDeviceCatCount('all');
        this.$nextTick(function () {
          _this.initMap();
        });
      }
      if (type == 'default') {
        _this.$router.push({
          name: 'home'
        })
        location.reload()
        this.GetDeviceAbnormalCountMonth();
        this.GetDeviceCatCount('all');
        // 图表在线离线数据（yhj）
        _this.GetDeviceZLData();
        // 告警异常处理情况图表数据
        _this.GetEchartAbData();
        this.getUserDevicesPageV2();
        this.$nextTick(function () {
          _this.initMap();
        });
      }
      if (type == 'DMapMode') {

        _this.$router.push({
          name: 'homebak1'
        })
      }
    },
    // 设置首页
    setHome(type) {
      if (type != 'newHome') {
        // 图表在线离线数据（yhj）
        this.GetDeviceZLData();
        // 告警异常处理情况图表数据
        this.GetEchartAbData();
      }
      this.$store.commit("setHomeType", type);
      localStorage.setItem('HomeType', type);
    },
    PlaySound() {
      this.PlayIndex = true;
      Cookies.set('PlayIndex', true);
    },

    StopSound() {
      this.PlayIndex = false;
      Cookies.set('PlayIndex', false);
    },

    // 退出登录
    ok() {
      let _this = this;
      Cookies.set('Token', '');
      Cookies.set('AdminData', '');
      _this.$store.dispatch("setCodeValue", ``);
      // _this.$store.dispatch("setHomeType", "newHome");
      // localStorage.setItem('HomeType', "newHome");
      if (window.location.host == 'xed.hxpwr.com') {
        this.$router.push({
          name: 'xed_login'
        })
      } else {
        this.$router.push({
          name: 'login'
        })
      }
    },
    cancel() { },
    onSelectChange(item) {
      this.parameter = "";
      this.headTitle = item.title;
      this.query = {};
      switch (item.grade) {
        case 1:
          this.parameter = `&Ccode=${item.Ccode}`;
          this.query = {
            Ccode: item.Ccode
          }
          break;
        case 2:
          this.parameter = `&Vcode=${item.Vcode}`;
          this.query = {
            Vcode: item.Vcode
          }
          break;
        case 3:
          this.parameter = `&Scode=${item.Scode}`;
          this.query = {
            Scode: item.Scode
          }
          break;
        case 4:
          this.parameter = `&Zcode=${item.Zcode}`;
          this.query = {
            Zcode: item.Zcode
          }
          break;
        case 5:
          this.parameter = `&RoomCode=${item.RoomCode}`;
          this.query = {
            Zcode: item.Zcode
          }
          break;
        default:
          break;
      }
      if (item.Jd && item.Wd) {
        this.cityName = item.CityName
      } else {
        this.cityName = Cookies.get("cityName") || this.$t('smartCity.HomeBak1.282798-39')
      }
      this.GetDeviceAbnormalPageListWith3Code();
      // this.GetDeviceZLData();
      this.GetUserDevicesPage();
      this.GetRoshRoomList();
    },

    GetRoshRoomList() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: `api/User/GetRoshRoomList`,
        data: {
          ...this.query
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        if (res.Success) {
          this.roomConfig = {
            header: [this.$t('smartCity.HomeBak1.282798-40'), this.$t('smartCity.HomeBak1.282798-41'), this.$t('smartCity.HomeBak1.282798-42')],
            align: ["center"],
            headerBGC: "rgba(0,0,0,0.12)",
            rowNum: 4,
            oddRowBGC:
              this.themeCode === "default"
                ? "rgba(84, 180, 168, 0.6)"
                : "rgba(16, 37, 98, 0.6)",
            evenRowBGC:
              this.themeCode === "default"
                ? "rgba(84, 180, 168, 0.2)"
                : "rgba(16, 37, 98, 0.2)",
            data: (res.Data || []).map(item => {
              return [
                item.RoomName || '-',
                item.OwnerPhone || '-',
                item.OrganizationName || '-'
              ];
            })
          };
        }
      });
    },





    intercept(value) {
      if (!value) return "";
      return value.slice(11, 19);
    },


    goBack() {
      this.$router.push({
        name: "home"
      });
    },

  },
  filters: {
    intercept: function (value) {
      if (!value) return '';
      return value.slice(11, 16);
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
@import "./big_screen_default.scss";
@import "./big_screen.scss";
@import "./home_back1.scss";

.ifram_bgclo {
  background-color: #fff;
  width: 100vw;
  height: 100vh;
}

.iframeMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background: rgba(0, 0, 0, 0);
  pointer-events: none;
}

.hide {
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 1s, transform 1s;
}

.hideLeft2 {
  opacity: 0;
  transform: translateX(-200%);
  transition: opacity 1s, transform 1s;
}

.hideRight {
  opacity: 0;
  transform: translateX(100%);
  transition: opacity 1s, transform 1s;
}

.show {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 1s, transform 1s;
}
</style>
  


// WEBPACK FOOTER //
// src/components/smartCity/homebak1.vue